<template>
  <div>
    <Header
      @submit="onSearch"
      @registration="onRegistration"
      @manual="scrollFormIntoView"
    />
    <Forms v-bind.sync="formProps" />
  </div>
</template>

<script>
import Vue from 'vue';
import Header from '@/components/Header';
import Forms from '@/components/Forms';

export default Vue.extend({
  components: {
    Header,
    Forms
  },
  data: () => ({
    formProps: {
      vehicle: {},
      customer: {
        address: {}
      }
    }
  }),
  methods: {
    onSearch(result) {
      if (result) {
        this.formProps = result;
        this.scrollFormIntoView();
      }
    },
    onRegistration(result) {
      this.formProps = {
        vehicle: result.vehicle,
        customer: result.customer,
        insurance: result.insurance
      };
      this.scrollFormIntoView();
    },
    scrollFormIntoView() {
      this.$el.querySelector('#form').scrollIntoView({ behavior: 'smooth' });
    }
  }
});
</script>
